/* SHOPAAREL LUX — Pro combos.
   A combo is its own product with its own price. Every shade combination is a real variant of the combo
   (option "Shades", e.g. "Shade 03 + Shade 07" or "02 MOOD + 05 CRUSH"), so the chosen shades show in the
   Shiprocket cart, checkout, order, invoice and shipping panel. This script lets the shopper pick a shade for
   each item, looks up the matching variant, and adds ONE combo line with the shades also kept as line-item
   properties ("1. Your everyday shade: Silky Matte Lipstick · 02 MOOD") plus _combo_variants for stock sync. */
(function () {
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var rupee = function (p) { return '₹' + Math.round(p / 100).toLocaleString('en-IN'); };

  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'sp-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = '<span>' + msg + '</span><a href="/cart">View bag</a>';
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 4200);
  }
  function burst(el) {
    if (RM || !el) return;
    for (var k = 0; k < 10; k++) {
      var s = document.createElement('i'); s.className = 'sp-burst';
      var a = k / 10 * 6.283 + Math.random() * 0.4, d = 20 + Math.random() * 12;
      s.style.setProperty('--dx', (Math.cos(a) * d).toFixed(1) + 'px'); s.style.setProperty('--dy', (Math.sin(a) * d).toFixed(1) + 'px');
      el.appendChild(s); setTimeout(function (x) { return function () { x.remove(); }; }(s), 800);
    }
  }
  function addToCart(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); })
      .then(function (res) {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          $$('[data-cart-count], .header__cart-count, [data-js-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
        }).catch(function () {});
        return res;
      });
  }

  /* shade combination -> combo variant id, via the storefront API (combos can have 800+ variants) */
  var VQ = 'query($id:ID!,$v:String!){node(id:$id){...on ProductVariant{product{variantBySelectedOptions(selectedOptions:[{name:"Shades",value:$v}]){id availableForSale}}}}}';
  var vcache = {};
  function lookupVariant(baseVid, value, tries) {
    if (vcache[value]) return Promise.resolve(vcache[value]);
    return fetch('/api/2025-01/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ query: VQ, variables: { id: 'gid://shopify/ProductVariant/' + baseVid, v: value } }) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var v = j && j.data && j.data.node && j.data.node.product && j.data.node.product.variantBySelectedOptions;
        if (!v) throw new Error('no variant');
        var id = +String(v.id).split('/').pop(); vcache[value] = id; return id;
      })
      .catch(function (e) { if ((tries || 0) < 1) return lookupVariant(baseVid, value, (tries || 0) + 1); throw e; });
  }

  /* true shade colour: every Shopaarel shade image has a solid colour strip on its right edge */
  var cache = {}; try { cache = JSON.parse(localStorage.getItem('sp-shade-hex') || '{}'); } catch (e) {}
  function saveCache() { try { localStorage.setItem('sp-shade-hex', JSON.stringify(cache)); } catch (e) {} }
  function shadeColor(url, cb) {
    if (!url) return;
    var key = url.split('?')[0].split('/').pop(); if (cache[key]) return cb(cache[key]);
    var im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var c = document.createElement('canvas'); c.width = im.naturalWidth; c.height = im.naturalHeight;
        var x = c.getContext('2d'); x.drawImage(im, 0, 0);
        var d = x.getImageData(Math.floor(c.width * 0.96), Math.floor(c.height * 0.08), 1, 1).data;
        var hex = '#' + [d[0], d[1], d[2]].map(function (v) { return ('0' + v.toString(16)).slice(-2); }).join('');
        cache[key] = hex; saveCache(); cb(hex);
      } catch (e) {}
    };
    im.src = url;
  }

  function initCombo(c) {
    if (c._i) return; c._i = 1;
    var name = c.getAttribute('data-name') || 'Pro combo';
    var comboVid = +c.getAttribute('data-vid'), price = +c.getAttribute('data-price') || 0, save = +c.getAttribute('data-save') || 0;
    var slots = $$('[data-slot]', c);
    var need = slots.filter(function (s) { return s.classList.contains('is-choose'); }).length;
    var wasReady = need === 0;

    $$('.sp-dot', c).forEach(function (d) {
      shadeColor(d.getAttribute('data-src'), function (hex) { var cc = $('.sp-dot__c', d); cc.style.backgroundImage = 'none'; cc.style.backgroundColor = hex; d.setAttribute('data-hex', hex); });
    });

    function missing() { return slots.filter(function (s) { return s.classList.contains('is-choose') && !s.getAttribute('data-vid'); }); }
    /* the combo variant name for the chosen shades: same-product shades sorted, numbers shown as "Shade 03" */
    function shadesValue() {
      var ch = slots.filter(function (s) { return s.classList.contains('is-choose'); });
      if (!ch.length) return null;
      var same = ch.every(function (s) { return s.getAttribute('data-ptitle') === ch[0].getAttribute('data-ptitle'); });
      var arr = ch.map(function (s) { return { v: +s.getAttribute('data-vid'), t: s.getAttribute('data-shade') || '' }; });
      if (same) arr.sort(function (a, b) { return a.v - b.v; });
      return arr.map(function (x) { return /^\d+$/.test(x.t) ? 'Shade ' + x.t : x.t; }).join(' + ');
    }
    function resolveVid() {
      var val = shadesValue();
      if (!val) return Promise.resolve(comboVid);
      return lookupVariant(comboVid, val);
    }
    function paint() {
      var m = missing().length, done = need - m, ready = m === 0;
      $$('[data-combo-fill]', c).forEach(function (f) { f.style.width = need ? (done / need * 100) + '%' : '100%'; });
      $$('[data-combo-buy]', c).forEach(function (btn) {
        if (btn.disabled) return;
        btn.classList.toggle('is-ready', ready);
        var main = $('[data-combo-buy-label]', btn), sub = $('[data-combo-buy-sub]', btn), short = main && main.hasAttribute('data-short');
        if (!main) return;
        if (ready) {
          main.textContent = short ? 'Buy combo' : 'Buy combo now';
          if (sub) sub.textContent = rupee(price) + (save > 0 ? ' · you save ' + rupee(save) : '');
        } else if (short) {
          main.textContent = m === need ? 'Choose shade' + (need > 1 ? 's' : '') : m + ' more to go';
        } else {
          main.textContent = m === need ? 'Choose your ' + (need > 1 ? need + ' shades' : 'shade') : 'Choose ' + m + ' more shade' + (m > 1 ? 's' : '');
          if (sub) sub.textContent = (save > 0 ? 'Unlock ' + rupee(save) + ' off · ' : '') + done + ' of ' + need + ' done';
        }
        if (ready && !wasReady) { btn.classList.remove('is-pop'); void btn.offsetWidth; btn.classList.add('is-pop'); }
      });
      if (ready && need) resolveVid().catch(function () {}); /* warm the lookup so the add is instant */
      wasReady = ready;
    }
    function open(s) {
      slots.forEach(function (x) { if (x !== s) { x.classList.remove('is-open'); var h = $('[data-step-toggle]', x); h && h.setAttribute('aria-expanded', 'false'); } });
      if (s) { s.classList.add('is-open'); var h = $('[data-step-toggle]', s); h && h.setAttribute('aria-expanded', 'true'); }
    }
    function guard() {
      var m = missing()[0]; if (!m) return true;
      open(m);
      m.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' });
      m.classList.remove('is-flash'); void m.offsetWidth; m.classList.add('is-flash');
      return false;
    }
    /* ONE combo line: the variant named after the chosen shades; the shades also travel as order details */
    function items(vid) {
      var props = {};
      slots.forEach(function (s) {
        var shade = s.getAttribute('data-shade');
        props[s.getAttribute('data-key')] = s.getAttribute('data-ptitle') + (shade ? ' · ' + shade : '');
      });
      props._combo_variants = slots.map(function (s) { return s.getAttribute('data-vid'); }).join(',');
      return [{ id: vid || comboVid, quantity: 1, properties: props }];
    }
    function addCombo() { return resolveVid().then(function (vid) { return addToCart(items(vid)); }); }

    slots.forEach(function (s) {
      var tg = $('[data-step-toggle]', s);
      tg && tg.addEventListener('click', function () { if (s.classList.contains('is-open')) { s.classList.remove('is-open'); tg.setAttribute('aria-expanded', 'false'); } else open(s); });
      $$('.sp-dot', s).forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled) return;
          $$('.sp-dot', s).forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
          b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true');
          burst(b);
          var title = b.getAttribute('data-title');
          s.setAttribute('data-vid', b.getAttribute('data-vid')); s.setAttribute('data-shade', title);
          s.classList.add('is-done');
          var ch = $('[data-slot-chosen]', s); if (ch) ch.textContent = 'Shade ' + title;
          var nm = $('[data-dot-name]', s); if (nm) nm.innerHTML = 'Selected: <b>' + title + '</b>';
          var dot = $('[data-slot-dot]', s); if (dot) { dot.classList.add('has-color'); var hex = b.getAttribute('data-hex'); dot.style.background = hex || ''; if (!hex) { dot.style.backgroundImage = $('.sp-dot__c', b).style.backgroundImage; dot.style.backgroundSize = '1600%'; dot.style.backgroundPosition = '100% 8%'; } }
          var big = b.getAttribute('data-big'), cs = $('[data-collage-slot="' + s.getAttribute('data-collage') + '"] img', c);
          if (big && cs) { cs.removeAttribute('srcset'); cs.src = big; }
          paint();
          var next = missing()[0];
          setTimeout(function () { if (next) open(next); else s.classList.remove('is-open'); }, 380);
        });
      });
    });

    $$('[data-combo-buy]', c).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled || !guard()) return;
        $$('[data-combo-buy-label]', c).forEach(function (l) { l.textContent = 'Opening checkout…'; });
        addCombo().then(function () {
          var sr = $('.sp-combo__sr .sr-headless-checkout', c);
          if (sr) { sr.click(); setTimeout(paint, 5000); }
          else location.href = '/checkout';
        }).catch(function (err) { paint(); toast((err && err.description) || 'Could not add — please try again'); });
      });
    });
    var addBtn = $('[data-combo-add]', c);
    addBtn && addBtn.addEventListener('click', function () {
      if (!guard()) return;
      var sp = $('span', addBtn), lbl = sp.textContent; addBtn.disabled = true; sp.textContent = 'Adding…';
      addCombo().then(function () {
        sp.textContent = 'Added ✓'; toast(name + ' added to your bag');
        setTimeout(function () { sp.textContent = lbl; addBtn.disabled = false; }, 1800);
      }).catch(function (err) { sp.textContent = lbl; addBtn.disabled = false; toast((err && err.description) || 'Could not add — please try again'); });
    });

    var sticky = $('[data-combo-sticky]', c), cta = $('[data-combo-cta]', c);
    if (sticky && cta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        var on = !e[0].isIntersecting; sticky.classList.toggle('is-on', on); document.body.classList.toggle('sp-has-sticky', on);
      }, { rootMargin: '0px 0px -60px 0px' }).observe(cta);
    }
    paint();
  }

  function initHub(h) {
    if (h._i) return; h._i = 1;
    var chips = $$('[data-filter]', h), cards = $$('[data-cat-wrap]', h);
    chips.forEach(function (ch) {
      ch.addEventListener('click', function () {
        chips.forEach(function (x) { x.classList.toggle('is-active', x === ch); });
        var f = ch.getAttribute('data-filter');
        cards.forEach(function (cd) { cd.classList.toggle('is-hidden', f !== 'all' && cd.getAttribute('data-cat-wrap') !== f); });
      });
    });
  }

  function init(root) { $$('[data-sp-combo]', root || document).forEach(initCombo); $$('[data-sp-combo-hub]', root || document).forEach(initHub); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
